const EDGE_TO_EDGE_TEMPLATE_IDS = new Set(['focus-sidebar']);

export const DEFAULT_PDF_MARGIN_IN = 0.4;

export function isEdgeToEdgeTemplate(templateId?: string): boolean {
  return Boolean(templateId && EDGE_TO_EDGE_TEMPLATE_IDS.has(templateId));
}

export function getPdfMarginInForTemplate(templateId?: string): number {
  return isEdgeToEdgeTemplate(templateId) ? 0 : DEFAULT_PDF_MARGIN_IN;
}

export function getPdfOptionsForTemplate(templateId?: string): Record<string, unknown> | undefined {
  if (!isEdgeToEdgeTemplate(templateId)) {
    return undefined;
  }

  return {
    format: 'A4',
    printBackground: true,
    preferCSSPageSize: true,
    margin: {
      top: '0in',
      right: '0in',
      bottom: '0in',
      left: '0in',
    },
  };
}
